<template>
  <div style="margin: 0 16px 24px;">
    <div class="stock-info">
        <div class="stock-info-text">
          <div class="info-item"><p class="info-title">商品名称：</p><span>{{stockForm.commodityName}}</span></div>
          <div class="info-item"><p class="info-title">供应商：</p><span>{{stockForm.supplierName}}</span></div>
          <div class="info-item"><p class="info-title">品牌：</p><span>{{stockForm.brandName}}</span></div>

        </div>
        <div class="stock-info-text">
          <div class="info-item"><p class="info-title">商品规格：</p><span>{{stockForm.specification}}</span></div>
          <div class="info-item" v-if="showInfo"><p class="info-title">进货单价：</p><span>{{stockForm.price}}</span></div>
          <div class="info-item"><p class="info-title">计量单位：</p><span>{{stockForm.measureUnitName}}</span></div>
        </div>
        <div class="stock-info-text" v-if="showInfo">

          <div class="info-item"><p class="info-title">建议零售价：</p><span>{{stockForm.retailPrice}}</span></div>
          <div class="info-item"><p class="info-title">库存量：</p><span>{{stockForm.stockNum}}</span></div>
          <div class="info-item"><p class="info-title">出库量：</p><span>{{stockForm.stockOutNum}}</span></div>
        </div>
        <div class="stock-info-text" v-if="showInfo">
          <div class="info-item">
            <p class="info-title">门店零售价：</p>
            <span @click="editPriceNum" class="edit-btn">{{stockForm.shopRetailPrice}}</span>
          </div>
          <div class="info-item">
            <p class="info-title">预警库存量：</p>
            <span @click="editPriceNum" class="edit-btn">{{stockForm.stockWarnNum}}</span>
          </div>
        </div>
    </div>

    <div class="content-input" style="margin-top: 24px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>库存变动</label>
          <el-select v-model="preType" placeholder="Select" class="select-item" @change="preTypeChange">
            <el-option v-for="item in preTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>变动类型</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="变动时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>批次号</label>
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>

    <div class="content-table" style="width: 100%; margin-top: 8px">
      <div style="margin-bottom: 16px;" v-if="(operateState & 4) == 4">
        <el-button  type="primary" @click="addStock(-1)">系统出库</el-button>
        <el-button style="margin-right: 16px;"  type="danger" @click="addStock(1)">系统入库</el-button>
        <span v-if="showTotalSum">总数：{{totalSum}}</span>
      </div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          v-loading="listLoading"
          @selection-change="selsChange"
          @header-click="selsAll"
          @cell-click="toggleSelection"
          size="default"
          style="width: 100%"
          border
      >
<!--        <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
        <el-table-column property="type" label="类型">
          <template #default="scope">
            <p>{{scope.row.type == -5?'核销券码':scope.row.type == -4?'报损出库':scope.row.type == -3?'赠送出库':scope.row.type == -2?'售卖出库':scope.row.type == -1?'系统出库':scope.row.type == 1?'系统入库':scope.row.type == 2?'采购入库':'' }}</p>
          </template>
        </el-table-column>
        <el-table-column property="num" label="出入库数量">
          <template #default="scope">
            {{scope.row.num + scope.row.giveNum}}<span v-if="scope.row.giveNum">（{{scope.row.giveNum}}）</span>
          </template>
        </el-table-column>
        <el-table-column property="money" label="出入库总计"/>
        <el-table-column property="stockNum" label="出入库后数量"/>
        <el-table-column property="updateTime" label="出入库时间" width="200"/>
        <el-table-column property="numberNo" label="关联批次号"/>
        <el-table-column property="adminName" label="添加人"/>
        <el-table-column property="remark" label="备注" class-name="cursor"/>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";
import {getFormData, postFormData} from "@/api/api";
import {getShopCommodityDetailList, updatePurchaseState, pageShopCommodityDetailSummary} from "@/api/url";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import Dialog from "@/assets/js/dialog";
import RefusalReasonDialog from "@/views/stock/components/RefusalReasonDialog";
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import StockRemarkDialog from "@/views/stock/components/StockRemarkDialog";
import CommodityRemarkDialog from "@/views/stock/components/CommodityRemarkDialog";
import AddCommodityStockDialog from "@/views/stock/components/AddCommodityStockDialog";
import EditPriceNumDialog from "@/views/stock/components/EditPriceNumDialog";

export default {
  name: "StockListDialog",
  components: {DatePickerRange, SearchComponents},
  props: {
    value: Object
  },
  data() {
    return {
      stockForm: this.value.stockForm,
      // showBtn: this.value.showBtn,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      idArray: [],

      batchLoading: false,

      preTypeArray: [
        {label: '不限', value: -1},
        {label: '入库', value: 1},
        {label: '出库', value: 2}
      ],
      preType: -1,

      typeArray: [
        {label: '不限', value: 0}
      ],

      type2Array: [
        {label: '报损出库', value: -4},
        {label: '赠送出库', value: -3},
        {label: '售卖出库', value: -2},
        {label: '系统出库', value: -1},
        {label: '核销券码', value: -5},
      ],
      type1Array: [
        {label: '系统入库', value: 1},
        {label: '采购入库', value: 2}
      ],

      type: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '关联批次号', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      visiblePrice: false,

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

      totalSum: '',

      showTotalSum: false,
      showInfo: this.value.showInfo

    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.preType = -1;
      // this.limitState = false;
      this.preType = -1;
      this.type = 0;
      this.searchValue = '';
      this.searchType = 1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },


    preTypeChange() {
      this.type = 0
      this.typeArray = [
        {label: '不限', value: 0}
      ]
      if(this.preType == -1) {
        this.typeArray = [...this.typeArray, ...this.type1Array, ...this.type2Array]
      }
      if(this.preType == 1) {
        this.typeArray = [...this.typeArray, ...this.type1Array]
      }
      if(this.preType == 2) {
        this.typeArray = [...this.typeArray, ...this.type2Array]
      }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.commodityId,
          width: 908,
          from: 2
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      // if(column.type == 'selection') {
      //   this.$refs.multipleTableRef.toggleRowSelection(row)
      // }

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: CommodityRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

    },

    editPriceNum() {
      Dialog.open({
        title: '',
        component: EditPriceNumDialog,
        data: {
          stockForm: this.stockForm,
          width: '500px'
        },
        confirm: (result) => {
          this.stockForm.shopRetailPrice = result.shopRetailPrice
          this.stockForm.stockWarnNum = result.stockWarnNum
        }
      })
    },

    addStock(type) {
      let _title = ''
      if(type == -1) _title = '系统出库'
      if(type == 1) _title = '系统入库'
      Dialog.open({
        title: _title,
        component: AddCommodityStockDialog,
        data: {
          type: type,
          stockForm: this.stockForm,
          width: '500px'
        },
        confirm: (result) => {
          if(type == -1) {
            this.stockForm.stockNum = Number(this.stockForm.stockNum) - Number(result.num)
          }else {
            this.stockForm.stockNum = Number(this.stockForm.stockNum) + Number(result.num)
          }
          this.getPage()
        }
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        if(this.preType > -1 || this.type != 0) {
          this.showTotalSum = true
        }else {
          this.showTotalSum = false
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['preType'] = this.preType;
      param['type'] = this.type;
      // param['limitState'] = this.limitState?1:0;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.stockForm.shopId;
      param['commodityId'] = this.stockForm.commodityId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopCommodityDetailList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getSumNum(param)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getSumNum(params) {
      getFormData(pageShopCommodityDetailSummary,params).then(data => {
          this.totalSum = data.data.totalSum
      })
    }



  },

  mounted() {
    this.getPage()
    this.preTypeChange()
  }


}
</script>

<style scoped>
.stock-info{
  display: flex;
  /*align-items: center;*/
  justify-content: space-around;
  /*background-color: #f5f7fa;*/
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 24px;
}
.item-img {
  width: 56px;
  height: 56px;
}
.stock-info-img {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.stock-info-text {
  width: 25%;
}

.info-title{
  /*width: 70px;*/
  /*text-align: right;*/
  font-weight: bold;
}

.info-item {
  display: flex;
  align-items: center;
  margin: 3px 0;
}

.edit-btn {
  color: #409eff;
  cursor: pointer;
}

.edit-btn:hover {
  text-decoration: underline;
}

</style>
